import type { DetailsSummaryADFQuery_detailsLines_detailLines_labels } from '../queries/__types__/DetailsSummaryADFQuery.ts';

export const extractAllLabelsText = (
	labels: (DetailsSummaryADFQuery_detailsLines_detailLines_labels | null)[],
): string => {
	const names = labels.map((label) => label?.name || '');
	return ''.concat(...names);
};
